import _ from "lodash";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import "./GlobalWidgetConfig.scss";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { getPoisForConnectionMapping } from "@/helpers/poiHelper";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "GlobalWidgetConfig",
  data: () => ({
    radioGroup: 0,
    pois: [],
    config: {
      currentSeason: "",
      filter: {
        include: {
          featureGroups: [],
          features: [],
          categoryTypes: [],
          categories: []
        },
        exclude: {
          featureGroups: [],
          features: [],
          categoryTypes: [],
          categories: [],
          pois: []
        }
      },
      export: {
        seasonFeatures: { summer: [], winter: [] },
        categoryTypes: [],
        features: [],
        poweredByTitle: "",
        poweredByLink: "",
        poweredByImage: "",
        sourceLink: "",
        defaultPrice: false,
        pricesWithFeatures: []
      }
    },
    snackbar: false,
    snackbarColor: "",
    snackbarText: ""
  }),
  async mounted() {
    await this.$store.dispatch("getFeatureGroupsForPois");
    await this.$store.dispatch("getCategories");
    await this.$store.dispatch("getCategoryGroups");
    await this.$store.dispatch("getGlobalConfig");
    this.pois = await getPoisForConnectionMapping(this.selectedPrincipal.id);
    Object.assign(this.config, this.globalConfig);
  },
  methods: {
    async saveConfig() {
      const headers = getTokenHeader();
      try {
        const res = await axios.put(
          `${env.poi_api_client_url}config/${this.selectedPrincipal?.id}/`,
          this.config,
          { headers }
        );
        if (res.status === 200) {
          this.createSuccess("Speichern erfolgreich");
        } else this.createError(res);
      } catch (ex) {
        this.createError();
      }
    },
    async cancel() {
      const res = await this.$confirm(
        "Sind Sie sicher, dass sie alle Änderungen verwerfen wollen?",
        confirmWarningConfig
      );
      if (res) await this.$router.push("/poi/config");
    },
    createError(ex) {
      this.snackbarText =
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal";
      this.snackbarColor = "#c55c52";
      this.snackbar = true;
      console.error(ex);
    },
    createSuccess(message) {
      this.snackbarText = message;
      this.snackbarColor = "#00636C";
      this.snackbar = true;
    },
    updateSeasonFeatureValues(value, key) {
      if (Array.isArray(value)) value = value[0];
      if (this.config?.export?.seasonFeatures)
        this.config.export.seasonFeatures[key] = value;
    },
    updateValue(value, key) {
      if (this.config?.export) this.config.export[key] = value;
      this.$forceUpdate();
    }
  },
  computed: {
    featureGroups() {
      return this.$store.state.featureGroups;
    },
    features() {
      return _.sortBy(
        _.flatten(this.$store.state.featureGroups.map(fg => fg.features)),
        "title"
      );
    },
    categoryGroups() {
      return this.$store.state.categoryGroups;
    },
    categories() {
      const categories = [];
      this.categoryGroups
        .filter(ct => ct.categories?.length)
        .forEach(ct => {
          categories.push({ ...ct, header: ct.title });
          ct.categories.forEach(cat => {
            categories.push({ ...cat });
          });
        });
      return categories;
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    globalConfig() {
      return this.$store.state.globalConfig;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    }
  },
  components: { TreeViewSelection }
};
